import { Pipe } from "@angular/core";
import { Record as AppRecord } from "src/app/models/record";
import { Util } from "src/app/util";
import { CardItemLink } from "../../components/card-item/card-item.interface";

@Pipe({
  name: 'infoUrl'
})
export class InfoUrlPipe {

  transform(record: AppRecord, extraParams?: Record<string, string | undefined>, state?: Record<string, unknown>): CardItemLink {
    const slug = Util.slugifyRecord(record);
    const queryParams = this.buildQueryParams(extraParams);

    return {
      path: `/info/${slug}`,
      queryParams,
      state,
    };
  }

  private buildQueryParams(extraParams: Record<string, string>) {
    if (!extraParams || Object.values(extraParams).every((v) => v === undefined)) {
      return undefined;
    }

    return Object.entries(extraParams).reduce((acc, [key, value]) => {
      if (value !== undefined && value !== null) {
        acc[key] = value;
      }
      return acc;
    }, {});
  }
}
